import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_card_header __sub" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "p-jobsearch-search_card_header_hl" }, "業種を選択"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-search_card_header_back js-modal-close-trigger",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "戻る")
  ])
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_card_body __sub js-tab-container" }
const _hoisted_4 = { class: "p-jobsearch-search_card_sub __no-sp" }
const _hoisted_5 = { class: "p-jobsearch-search_tab" }
const _hoisted_6 = ["data-tab"]
const _hoisted_7 = { class: "p-jobsearch-search_card_main __no-tab" }
const _hoisted_8 = {
  class: "p-jobsearch-search_content __sub",
  id: "jobsearch-industry-dialog-body"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "p-jobsearch-search_accordion __first" }
const _hoisted_11 = { class: "p-jobsearch-search_accordion_wp js-check-parent_wp" }
const _hoisted_12 = { class: "p-jobsearch-search_check" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "p-jobsearch-search_accordions __second" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-search_check_icon" }, null, -1)
const _hoisted_18 = ["checked", "onChange"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_bg js-modal-close-trigger" }, null, -1)

import { JobSearchSelectedCheckboxListItem } from '@/types';
import { DialogIndustryData, Level1MstIndustry, Level2MstIndustry } from '@/types/mstMyPage';
import { domHelperUtils } from '@/utils/domHelper';
import { onMounted, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'Industry',
  props: {
    selectedIndustries: null,
    refreshKey: null
  },
  emits: ["update:selectedIndustries"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:selectedIndustries', value: {
    jobsearchIndsctgGroupId: string[],
    jobsearchIndsctgId: number[],
    displayIndustryList: JobSearchSelectedCheckboxListItem[],
  }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedIndustries?: {
    jobsearchIndsctgGroupId: string[],
    jobsearchIndsctgId: number[],
    displayIndustryList: JobSearchSelectedCheckboxListItem[],
  },
  refreshKey: number,
}

const dialogData = ref<DialogIndustryData>();
const storeBase = MYPAGE_CONSTANTS.STORE_MST;
// Props/Emitsの設定




watch(() => props.selectedIndustries, (newValue) => {
  if (newValue && dialogData.value) {
    updateCheckboxesFromIds(newValue);
  }
}, { deep: true });

watch(() => props.refreshKey, () =>{
  setTimeout(()=>{
    emit('update:selectedIndustries', selectedIndustries.value);
  });
});

// 選択された業種の計算プロパティ
const selectedIndustries = computed(() => {
  if (!dialogData.value) return {
    jobsearchIndsctgGroupId: [],
    jobsearchIndsctgId: [],
    displayIndustryList: [],
  };

  const result = {
    jobsearchIndsctgGroupId: [] as string[],
    jobsearchIndsctgId: [] as number[],
    displayIndustryList: [] as JobSearchSelectedCheckboxListItem[],
  };

  dialogData.value.selectbox1.forEach(box1 => {
    // selectbox1がチェックされている場合、そのIDをjobsearchIndsctgGroupIdに追加
    if (box1.isChecked) {
      result.jobsearchIndsctgGroupId.push(box1.id.toString());
      result.displayIndustryList.push({
        id: box1.value,
        // eslint-disable-next-line no-irregular-whitespace
        text: `${box1.text}　すべて`,
        isChecked: true,
        level: 1
      });
    } else {
      // selectbox1がチェックされていない場合、チェックされているselectbox2のIDをjobsearchIndsctgIdに追加
      box1.selectbox2.forEach(box2 => {
        if (box2.isChecked && !box2.id.toString().endsWith('00')) {
          result.jobsearchIndsctgId.push(Number(box2.id));
          result.displayIndustryList.push({
            id: box2.value,
            text: `${box1.text} - ${box2.text}`,
            isChecked: true,
            level: 2
          });
        }
      });
    }
  });

  return result;
});

// 条件をクリア
function clearAllSelections() {
  if (!dialogData.value) return;

  // すべてのチェックボックスの選択を解除
  dialogData.value.selectbox1.forEach(box1 => {
    // 第1階層のチェックボックスをクリア
    box1.isChecked = false;

    box1.selectbox2.forEach(box2 => {
      // 第2階層のチェックボックスをクリア
      box2.isChecked = false;
    });
  });

  // 親コンポーネントに空のオブジェクトを送信
  emit('update:selectedIndustries', {
    jobsearchIndsctgGroupId: [],
    jobsearchIndsctgId: [],
    displayIndustryList: [],
  });
}

// 指定する
function submitSelection() {
  emit('update:selectedIndustries', selectedIndustries.value);

  // remove opened items style
  const openedItems = document.querySelectorAll('#jobsearch-industry-dialog-body .-is-opened');
  setTimeout(() => {
    openedItems.forEach(item => {
      (item as HTMLElement).style = '';
    });
  });
}

// IDリストからチェックボックスの状態を更新
function updateCheckboxesFromIds(selectedData: {
  jobsearchIndsctgGroupId: string[],
  jobsearchIndsctgId: number[],
  displayIndustryList: JobSearchSelectedCheckboxListItem[],
}) {
  if (!dialogData.value) return;

  // まずすべてのチェックボックスをクリア
  dialogData.value.selectbox1.forEach(box1 => {
    box1.isChecked = false;
    box1.isOpened = false;
    box1.selectbox2.forEach(box2 => {
      box2.isChecked = false;
    });
  });

  // selectbox1（グループ）のチェックを設定
  dialogData.value.selectbox1.forEach(box1 => {
    if (selectedData.jobsearchIndsctgGroupId.includes(box1.id.toString())) {
      box1.isChecked = true;
      // グループがチェックされている場合、すべての子要素もチェック
      box1.selectbox2.forEach(box2 => {
        if (!box2.id.toString().endsWith('00')) {
          box2.isChecked = true;
        }
      });
    }
  });

  // selectbox2（個別）のチェックを設定（selectbox1がチェックされていない場合のみ）
  dialogData.value.selectbox1.forEach(box1 => {
    if (!box1.isChecked) {
      let isBox1Open = false;
      box1.selectbox2.forEach(box2 => {
        if (!box2.id.toString().endsWith('00') && selectedData.jobsearchIndsctgId.includes(Number(box2.id))) {
          box2.isChecked = true;
          isBox1Open = true;
        }
      });

      // box1の状態を更新（すべての子要素がチェックされていれば親もチェック）
      const allBox2Checked = box1.selectbox2
        .filter(b2 => !b2.id.toString().endsWith('00'))
        .every(box2 => box2.isChecked);
      box1.isChecked = allBox2Checked;
      if (allBox2Checked) {
        isBox1Open = false;
      }
      box1.isOpened = isBox1Open;
    }
  });

  // re-open checked sections
  setTimeout(() => {
    const openedItems = document.querySelectorAll('#jobsearch-industry-dialog-body .p-jobsearch-search_accordion_content.__second.-is-opened');
    openedItems.forEach(item => {
      if ((item as HTMLElement).style.display == 'none') {
        (item as HTMLElement).style.display = '';
      }
    });
  });
}

const store = useStore();
onMounted(async () => {
  dialogData.value = await store.dispatch(storeBase.DIALOG_INDUSTRY);

  // 初期選択値があれば設定
  if (props.selectedIndustries &&
    (props.selectedIndustries.jobsearchIndsctgGroupId.length > 0 ||
      props.selectedIndustries.jobsearchIndsctgId.length > 0)) {
    updateCheckboxesFromIds(props.selectedIndustries);
  }
});

// 第1階層チェックボックスの状態変更を処理する関数
function handleCheckbox1(checkbox: Level1MstIndustry, isChecked: boolean) {
  // 第1階層チェックボックスの状態を更新
  checkbox.isChecked = isChecked;

  // 第1階層に属するすべての第2階層（小分類）チェックボックスに
  // 同じチェック状態を適用（親子連動）
  checkbox.selectbox2.forEach(box2 => {
    box2.isChecked = isChecked;
  });
}

// 第2階層チェックボックスの状態変更を処理する関数
function handleCheckbox2(checkbox: Level2MstIndustry, isChecked: boolean) {
  // 第2階層チェックボックスの状態を更新
  checkbox.isChecked = isChecked;

  // 親階層（第1階層）のIDを取得（第2階層IDの先頭2桁が親ID）
  const parentBox1Id = checkbox.id.toString().substring(0, 2);

  // dialogDataから該当する親階層（第1階層）のオブジェクトを検索
  const box1Index = dialogData.value!.selectbox1.findIndex(box1 => box1.id == parentBox1Id);
  if (box1Index < 0) return;

  const box1 = dialogData.value!.selectbox1[box1Index];

  // 親階層（第1階層）のチェック状態を更新
  // 「全て選択」を表す項目（IDが親ID + 00）を除外して判定
  // 全ての子要素がチェックされている場合は親もチェック、そうでなければ親のチェックを外す
  const allBox2Checked = box1.selectbox2
    .filter(b2 => !b2.id.toString().endsWith('00'))
    .every(box2 => box2.isChecked);
  box1.isChecked = allBox2Checked;
}

function toggleBox1(target: HTMLElement, box1: Level1MstIndustry) {
  const checkboxContainer = target.parentElement?.nextElementSibling as HTMLElement;
  if (checkboxContainer) {
    if (box1.isOpened) {
      domHelperUtils.toggle.initOpen(checkboxContainer);
      domHelperUtils.toggle.closeAccordion(checkboxContainer);
    } else {
      domHelperUtils.toggle.openAccordion(checkboxContainer);
    }
  }
  box1.isOpened = !box1.isOpened;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: _normalizeClass(["p-jobsearch-search_tab_item js-tab-btn", { __current: !i}]),
                "data-tab": `industry-tab${i + 1}`
              }, _toDisplayString(item.text), 11, _hoisted_6))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (box1, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: box1.id,
                class: _normalizeClass(["p-jobsearch-search_tab-content js-tab-target", { __current: !i}]),
                id: `industry-tab${i + 1}`
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("input", {
                        class: "js-check-parent",
                        type: "checkbox",
                        checked: box1.isChecked,
                        onChange: ($event: any) => (handleCheckbox1(box1, ($event.target as HTMLInputElement).checked))
                      }, null, 40, _hoisted_14),
                      _createElementVNode("span", null, _toDisplayString(box1.text), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["p-jobsearch-search_accordion_btn js-jobsearch-acc-toggle", { '-is-opened': box1.isOpened }]),
                      onClick: ($event: any) => (toggleBox1($event.target as HTMLElement, box1))
                    }, "開閉ボタン", 10, _hoisted_15)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["p-jobsearch-search_accordion_content __second js-jobsearch-acc-target", { '-is-opened': box1.isOpened }])
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box1.selectbox2.filter(b2 => !b2.id.toString().endsWith('00')), (box2) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: box2.id,
                          class: "p-jobsearch-search_check"
                        }, [
                          _hoisted_17,
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: box2.isChecked,
                            onChange: ($event: any) => (handleCheckbox2(box2, ($event.target as HTMLInputElement).checked))
                          }, null, 40, _hoisted_18),
                          _createElementVNode("span", null, _toDisplayString(box2.text), 1)
                        ]))
                      }), 128))
                    ])
                  ], 2)
                ])
              ], 10, _hoisted_9))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", { class: "p-jobsearch-search_card_footer" }, [
        _createElementVNode("button", {
          class: "p-jobsearch-search_clear",
          id: "clearModalSearch4",
          type: "button",
          onClick: clearAllSelections
        }, "条件をクリア"),
        _createElementVNode("button", {
          class: "p-jobsearch-search_set js-modal-close-trigger",
          type: "button",
          onClick: submitSelection
        }, "指定する")
      ])
    ]),
    _hoisted_19
  ], 64))
}
}

})